"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARD_WIDTH = void 0;
var react_1 = __importDefault(require("react"));
exports.CARD_WIDTH = 150;
var Card = function (_a) {
    var supervisor = _a.supervisor;
    return (react_1.default.createElement("a", { href: supervisor.path, className: "coBlogSupervisorCarousel-Card_Container" },
        react_1.default.createElement("div", { className: "coBlogSupervisorCarousel-Card_ImageWrapper" },
            react_1.default.createElement("img", { src: supervisor.image.src, alt: supervisor.name, className: "coBlogSupervisorCarousel-Card_ImageWrapperInnerImage lazyload" })),
        supervisor.storeName &&
            (react_1.default.createElement("div", { className: "coBlogSupervisorCarousel-Card_StoreName" }, supervisor.storeName)),
        react_1.default.createElement("div", { className: "coBlogSupervisorCarousel-Card_Name" }, supervisor.name)));
};
exports.default = Card;
